var _rect, _rect2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsAppIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 12,
    fill: "url(#paint0_linear_18174_127198)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 12,
    fill: "#25D366"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18174_127198)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4562 15.485C30.2129 13.2388 27.2292 12.0011 24.0502 12C17.4996 12 12.1684 17.3307 12.1661 23.883C12.165 25.9776 12.7126 28.0221 13.7525 29.8239L12.0664 35.9825L18.3663 34.33C20.102 35.2771 22.0564 35.7757 24.0451 35.7762H24.0502C30.5997 35.7762 35.9316 30.445 35.9338 23.8927C35.9349 20.7171 34.7001 17.7318 32.4562 15.4856V15.485ZM24.0502 33.7693H24.0463C22.2741 33.7688 20.5356 33.2924 19.0188 32.3926L18.6581 32.1784L14.9195 33.159L15.9172 29.5139L15.6825 29.1401C14.6938 27.5674 14.1713 25.7497 14.1725 23.8836C14.1747 18.4378 18.6056 14.0069 24.0543 14.0069C26.6925 14.008 29.1724 15.0366 31.0373 16.9039C32.9024 18.7706 33.9286 21.2527 33.9275 23.8915C33.9252 29.3379 29.4943 33.7688 24.0502 33.7688V33.7693ZM29.4681 26.372C29.1712 26.2232 27.7114 25.5052 27.4389 25.4061C27.1666 25.3069 26.9689 25.2574 26.7711 25.5548C26.5734 25.8523 26.0042 26.5213 25.8309 26.719C25.6577 26.9173 25.4845 26.9418 25.1876 26.793C24.8908 26.6443 23.934 26.3309 22.7995 25.3195C21.9169 24.532 21.3208 23.5599 21.1476 23.2624C20.9744 22.965 21.1294 22.8043 21.2775 22.6567C21.4108 22.5234 21.5744 22.3097 21.7231 22.1365C21.8719 21.9632 21.9209 21.8391 22.02 21.6413C22.1192 21.443 22.0696 21.2698 21.9955 21.1211C21.9214 20.9724 21.3277 19.5107 21.0798 18.9164C20.8387 18.3375 20.5938 18.4162 20.412 18.4065C20.2387 18.3979 20.041 18.3962 19.8427 18.3962C19.6444 18.3962 19.323 18.4703 19.0507 18.7677C18.7783 19.0652 18.0113 19.7837 18.0113 21.2447C18.0113 22.7057 19.0752 24.1183 19.2239 24.3166C19.3726 24.5149 21.3179 27.5139 24.2964 28.8005C25.0047 29.1065 25.558 29.2894 25.9893 29.4262C26.7005 29.6524 27.3478 29.6205 27.8595 29.5441C28.4299 29.4587 29.6162 28.8256 29.8635 28.1321C30.1108 27.4386 30.1108 26.8437 30.0368 26.7201C29.9627 26.5964 29.7644 26.5218 29.4675 26.3731L29.4681 26.372Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18174_127198",
    x1: 2400,
    y1: 0,
    x2: 2400,
    y2: 4764.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18174_127198"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsAppIcon);
export default __webpack_public_path__ + "static/media/whats-app-icon.af6c256f.svg";
export { ForwardRef as ReactComponent };